<template>
  <div class="recent-comment-feed">
    <p v-if="loading" class="empty-state">Загрузка...</p>
    <p v-else-if="!comments.length" class="empty-state">Комментариев пока нет</p>

    <article v-for="comment in comments" :key="comment.id" class="recent-comment-item">
      <header class="recent-comment-header">
        <AuthorLink :author="comment.author" size="sm" class="recent-comment-author" />
        <span class="recent-comment-date">{{ formatDate(comment.created_at) }}</span>
      </header>

      <router-link
        class="recent-comment-parent"
        :to="parentRoute(comment)"
      >
        {{ parentLabel(comment) }}
      </router-link>

      <p v-if="comment.body" class="recent-comment-body">{{ comment.body }}</p>

      <PhotoSlider
        v-if="comment.photos?.length"
        :photos="comment.photos"
        compact
        class="recent-comment-photos"
      />
    </article>
  </div>
</template>

<script setup>
import PhotoSlider from './PhotoSlider.vue'
import AuthorLink from './AuthorLink.vue'

const props = defineProps({
  comments: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  kind: {
    type: String,
    required: true,
    validator: (value) => ['track', 'trip', 'event'].includes(value),
  },
})

function formatDate(value) {
  if (!value) return ''
  return new Date(value).toLocaleString('ru-RU')
}

function parentRoute(comment) {
  if (props.kind === 'track') {
    return { name: 'track', params: { id: comment.track.id } }
  }
  if (props.kind === 'event') {
    return { name: 'event', params: { id: comment.event.id } }
  }
  return { name: 'trip', params: { id: comment.trip.id } }
}

function parentLabel(comment) {
  if (props.kind === 'track') {
    return comment.track?.name || 'Трек'
  }
  if (props.kind === 'event') {
    return comment.event?.name || 'Событие'
  }
  return comment.trip?.name || 'Поездка'
}
</script>

<style scoped>
.recent-comment-feed {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.recent-comment-item {
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  padding: 0.75rem;
  background: #fff;
}

.recent-comment-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.125rem;
  font-size: 0.875rem;
  margin-bottom: 0.375rem;
}

.recent-comment-author {
  font-weight: 600;
}

.recent-comment-date {
  font-size: 0.75rem;
  color: #64748b;
  line-height: 1.3;
}

.recent-comment-parent {
  display: inline-block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #2563eb;
  text-decoration: none;
}

.recent-comment-parent:hover {
  text-decoration: underline;
}

.recent-comment-body {
  margin: 0;
  white-space: pre-wrap;
  font-size: 0.9375rem;
}

.recent-comment-photos {
  margin-top: 0.5rem;
}
</style>
